import { Job, JobModificationKeySchema } from "@core/domains/jobs";
import { apiEndpoint, internalApi } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { BUS_SERVICE } from "../config/index.ts";

export const busInternalApi = internalApi(
  { domain: API_DOMAIN, path: `${BUS_SERVICE.LABEL}/int` },
  {
    createJob: apiEndpoint({
      body: Job.createSchema.omit({ modificationKeyHash: true, status: true }),
      response: z.object(
        { job: Job.schema, modificationKey: JobModificationKeySchema },
        {
          job: "The job created, pending",
          modificationKey:
            "The one-time key a caller presents to update the job",
        },
      ),
    }),
    updateJob: apiEndpoint({
      body: z.object(
        {
          id: Job.shape.id,
          modificationKey: JobModificationKeySchema,
          principalId: Job.shape.principalId,
          resourceId: Job.shape.resourceId,
          type: Job.shape.type,
          update: Job.updateSchema,
        },
        {
          id: Job.descriptions.id,
          modificationKey: "The key the job's creation returned",
          principalId: Job.descriptions.principalId,
          resourceId: Job.descriptions.resourceId,
          type: Job.descriptions.type,
          update: "The changes to apply to the job",
        },
      ),
      response: z.object(
        { job: Job.schema },
        { job: "The job, with the changes applied" },
      ),
    }),
  },
);
